var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.filename
        ? _c(
            "Tooltip",
            { attrs: { title: _vm.filename } },
            [
              _c(_vm.extensionType, {
                tag: "component",
                staticClass: "h-8 w-8",
              }),
            ],
            1
          )
        : [_c(_vm.extensionType, { tag: "component", staticClass: "h-8 w-8" })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }